import { render, staticRenderFns } from "./IconMailSelect.vue?vue&type=template&id=4049d9dc&"
var script = {}
import style0 from "./IconMailSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4049d9dc')) {
      api.createRecord('4049d9dc', component.options)
    } else {
      api.reload('4049d9dc', component.options)
    }
    module.hot.accept("./IconMailSelect.vue?vue&type=template&id=4049d9dc&", function () {
      api.rerender('4049d9dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconMailSelect.vue"
export default component.exports